// src/pages/1_0_consultacliente.tsx

import React, { useState, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import AppNavbar from '../components/AppNavbar';
import BottomNav from '../components/BottomNav';
import { FaHome } from 'react-icons/fa';
import './Menu.css';
import './1_0_consultaCliente.css'; // Importa el CSS compacto

// Alias para el ícono de Home
const HomeIcon = FaHome as unknown as React.FC;

interface Servicio {
  perfil: string;
}

interface Facturacion {
  total_facturas: number;
}

interface Cliente {
  id: number;
  nombre: string;
  servicios?: Servicio[];
  facturacion?: Facturacion;
  estado: string;
  cedula?: string; // Se mostrará la cédula en los datos del cliente
  [key: string]: any;
}

const ConsultaCliente: React.FC = () => {
  const navigate = useNavigate();

  // Estados
  const [cedula, setCedula] = useState<string>('');
  const [cliente, setCliente] = useState<Cliente | null>(null);
  const [errorCliente, setErrorCliente] = useState<string>('');
  const [loadingCliente, setLoadingCliente] = useState<boolean>(false);

  const N8N_CLIENTE = process.env.REACT_APP_N8N_URL_CLIENTE_CEDULA!;

  const handleConsulta = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoadingCliente(true);
    setErrorCliente('');
    setCliente(null);

    try {
      const response = await fetch(N8N_CLIENTE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ cedula }),
      });

      if (!response.ok) throw new Error('Error en la consulta');
      const data = await response.json();
      if (data.estado !== 'exito' || !data.datos || data.datos.length === 0) {
        throw new Error('Cliente no encontrado');
      }
      setCliente(data.datos[0]);
    } catch (err: any) {
      setErrorCliente(err.message);
    } finally {
      setLoadingCliente(false);
    }
  };

  const handleVerFacturas = () => {
    navigate('/clientes/facturas', { state: { cliente } });
  };

  const handleNuevo = () => {
    setCedula('');
    setCliente(null);
    setErrorCliente('');
  };

  // Renderizado condicional
  if (loadingCliente) {
    return (
      <div className="consulta-cliente-container">
        <h1>Consulta de Cliente</h1>
        <div className="spinner-border text-primary mt-4" role="status">
          <span className="visually-hidden">Cargando...</span>
        </div>
        <p className="mt-2 text-center">Espere por favor...</p>
      </div>
    );
  }

  if (errorCliente) {
    return (
      <div className="consulta-cliente-container">
        <h1>Consulta de Cliente</h1>
        <div className="alert">
          <p>{errorCliente}</p>
          <button className="btn btn-secondary" onClick={handleNuevo}>
            Regresar
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="consulta-cliente-container">
      <AppNavbar />

      <h1>Consulta de Cliente</h1>

      {!cliente ? (
        <form onSubmit={handleConsulta}>
          <div className="mb-3">
            <label htmlFor="cedula" className="form-label">
              Número de Cédula
            </label>
            <input
              type="text"
              className="form-control"
              id="cedula"
              value={cedula}
              onChange={(e) => setCedula(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary">
            Consultar
          </button>
        </form>
      ) : (
        <div className="mt-4">
          <h2>Datos del Cliente</h2>
          <p><strong>ID Cliente:</strong> {cliente?.id}</p>
          <p><strong>Nombre Completo:</strong> {cliente?.nombre}</p>
          <p><strong>Cédula:</strong> {cliente?.cedula}</p>
          <p>
            <strong>Perfiles:</strong>{' '}
            {cliente.servicios && cliente.servicios.length > 0
              ? cliente.servicios.map((s, i) => (
                  <span key={i}>
                    {s.perfil}{i < cliente.servicios!.length - 1 ? ', ' : ''}
                  </span>
                ))
              : 'Sin perfiles asignados'}
          </p>
          <p>
            <strong>Valor Total de Facturas:</strong>{' '}
            {cliente.facturacion?.total_facturas ?? '-'}
          </p>
          <p>
            <strong>Estado del Servicio:</strong>{' '}
            {cliente.estado === 'ACTIVO' ? 'Activo' : 'Suspendido'}
          </p>
          <div className="mt-3">
            <button onClick={handleVerFacturas} className="btn btn-info me-2">
              Ver Facturas
            </button>
            <button onClick={handleNuevo} className="btn btn-secondary">
              Consultar de nuevo
            </button>
          </div>
        </div>
      )}
      <BottomNav />
    </div>
  );
};

export default ConsultaCliente;
